import { render, staticRenderFns } from "./UnitValues.vue?vue&type=template&id=415fe024&scoped=true&"
import script from "./UnitValues.vue?vue&type=script&lang=js&"
export * from "./UnitValues.vue?vue&type=script&lang=js&"
import style0 from "./UnitValues.vue?vue&type=style&index=0&id=415fe024&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415fe024",
  null
  
)

export default component.exports